module.exports = __webpack_public_path__ + "img/H2.a3b2f0d8.png";